var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlarmWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#alarm-warning_svg__clip0_4390_16227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 40V28a16 16 0 1132 0v12h2v4H6v-4h2zm4 0h24V28a12 12 0 00-24 0v12zM22 4h4v6h-4V4zm17.556 5.616l2.828 2.828-4.24 4.242-2.83-2.828 4.242-4.242zm-33.94 2.828l2.828-2.828 4.242 4.24-2.826 2.832-4.244-4.244zM14 28a10 10 0 0110-10v4a6 6 0 00-6 6h-4z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "alarm-warning_svg__clip0_4390_16227"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
}
export default __webpack_public_path__ + "static/svg/alarm-warning.svg";
export { SvgAlarmWarning as ReactComponent };